import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { RootState } from '@/store';
import { EmployerDetails } from '@/models/form/EmployerDetails.model';
import { City } from '@/models/form/PersonalDetails.model';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { MissingDocument } from '@/models/form/Documents.model';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import { FormHeaders } from '@/models/Form.model';
import EmployeeDetails from '@/views/dashboard/form101/steps/personal/EmployeeDetails.component.vue';
import { WizardFormErrors } from '@/models/form/WizardFormError';

// form state model object
export interface FormState {
  formHeaders: FormHeaders;
  form101Data: Form101DataModel;
  form101MetaData: Form101MetaData;
  formId: number | null;
  employeeDetails: EmployeeDetails;
  employerDetails: EmployerDetails;
  formReadOnlyMode: boolean;
  formSuccessDialog: boolean;
  openConfirmFormDialog: boolean;
  cities: City[];
  settlements: City[];
  formLoadingMode: boolean;
  progress: boolean;
  wizardHeaderTitle: string;
  createFormErrors: string[];
  editFormErrors: string[];
  noPdfError: boolean;
  noPdfErrors: string[];
  submitFormErrors: string[];
  formErrors: WizardFormErrors | null;
  missingDocuments: MissingDocument;
  tooltipId: string;
  formRejectedReason: string;
  formErrorsOpen: boolean;
  formErrorsShow: boolean;
  openSaveBeforeLeaveWizardModal: boolean;
  saveBeforeLeaveWizardRouteName: string;
  skipSaveBeforeLeaveWizardModal: boolean;
  deleteFormErrors: string[];
  openApproveFormDialog: boolean;
  openRejectFormDialog: boolean;
  openFormStatusHistoryDialog: boolean;
  openForm101ChangesDialog: boolean;
  openChooseFormOfficeModal: boolean;
  createFormLoading: boolean;
  openDeleteFormModal: boolean;
  approveDetailsChanges: boolean;
  compareEmployeeDetailsErrors: string[];
  openChangesNotificationModal: boolean;
}

// form state model init
export const initialState = (): FormState => {
  return {
    formHeaders: {} as FormHeaders,
    form101Data: {} as Form101DataModel,
    form101MetaData: {} as Form101MetaData,
    formId: null,
    employeeDetails: {} as EmployeeDetails,
    employerDetails: {} as EmployerDetails,
    cities: [],
    settlements: [],
    formLoadingMode: false,
    progress: false,
    formReadOnlyMode: false,
    formSuccessDialog: false,
    openConfirmFormDialog: false,
    wizardHeaderTitle: '',
    createFormErrors: [],
    editFormErrors: [],
    noPdfError: false,
    noPdfErrors: [],
    submitFormErrors: [],
    formErrors: null,
    openDeleteFormModal: false,
    approveDetailsChanges: true,
    compareEmployeeDetailsErrors: [],
    missingDocuments: {
      message: '',
      fieldKeys: [],
    },
    tooltipId: '',
    formRejectedReason: '',
    formErrorsOpen: false,
    formErrorsShow: false,
    openSaveBeforeLeaveWizardModal: false,
    saveBeforeLeaveWizardRouteName: '',
    skipSaveBeforeLeaveWizardModal: false,
    deleteFormErrors: [],
    openApproveFormDialog: false,
    openRejectFormDialog: false,
    openFormStatusHistoryDialog: false,
    openForm101ChangesDialog: false,
    openChooseFormOfficeModal: false,
    createFormLoading: false,
    openChangesNotificationModal: false,
  };
};

export const form: Module<FormState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
